import { BLOCKS } from "@contentful/rich-text-types";
import React, { ReactNode } from "react";
import { ReplaceQueryParams } from "../ReplaceQueryParams";

/* istanbul ignore next */
export default {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: unknown, children: ReactNode) => (
      <p className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></p>
    ),
    [BLOCKS.HEADING_1]: (_: unknown, children: ReactNode) => (
      <h1 className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></h1>
    ),
    [BLOCKS.HEADING_2]: (_: unknown, children: ReactNode) => (
      <h2 className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></h2>
    ),
    [BLOCKS.HEADING_3]: (_: unknown, children: ReactNode) => (
      <h3 className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></h3>
    ),
    [BLOCKS.HEADING_4]: (_: unknown, children: ReactNode) => (
      <h4 className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></h4>
    ),
    [BLOCKS.HEADING_5]: (_: unknown, children: ReactNode) => (
      <h5 className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></h5>
    ),
    [BLOCKS.HEADING_6]: (_: unknown, children: ReactNode) => (
      <h6 className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></h6>
    ),
    [BLOCKS.UL_LIST]: (_: unknown, children: ReactNode) => (
      <ul className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></ul>
    ),
    [BLOCKS.OL_LIST]: (_: unknown, children: ReactNode) => (
      <ol className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></ol>
    ),
    [BLOCKS.LIST_ITEM]: (_: unknown, children: ReactNode) => (
      <li className="richTextElement"><ReplaceQueryParams>{children}</ReplaceQueryParams></li>
    ),
  },
};
